import { FETCH_INTERVENTIONS_SUCCESS } from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

const setInterventionIds = (state, { payload: interventions, meta }) => {
  if (meta?.source === 'appointment-linked') {
    return interventions?.content?.map(({ id }) => id);
  }
  return state;
};

export default createReducer(initialState, {
  [FETCH_INTERVENTIONS_SUCCESS]: setInterventionIds,
});
